export function isBaseBriefingMap(url: string): boolean {
  return /^\/base-briefing(?:\/map)?\/?(?:[?#]|$)/.test(url);
}

export function selectedBaseCenter(base: any, bases: any[] = []): number[] | undefined {
  const center = (bases.find((item) => item.name === base?.name) ?? base)?.center;
  return Array.isArray(center) &&
    center.length === 2 &&
    center.every(Number.isFinite) &&
    Math.abs(center[0]) <= 180 &&
    Math.abs(center[1]) <= 90
    ? [...center]
    : undefined;
}

export function selectedBaseArea(base: any, bases: any[] = []): number[][] | undefined {
  const area = (bases.find((item) => item.name === base?.name) ?? base)?.area;
  if (
    !Array.isArray(area) ||
    area.length !== 2 ||
    !area.every(
      (point) =>
        Array.isArray(point) &&
        point.length === 2 &&
        point.every(Number.isFinite) &&
        Math.abs(point[0]) <= 180 &&
        Math.abs(point[1]) <= 90
    )
  )
    return;
  const bounds = [
    [Math.min(area[0][0], area[1][0]), Math.min(area[0][1], area[1][1])],
    [Math.max(area[0][0], area[1][0]), Math.max(area[0][1], area[1][1])],
  ];
  return bounds[0][0] < bounds[1][0] && bounds[0][1] < bounds[1][1] ? bounds : undefined;
}

export async function focusSelectedBase(
  settings: any,
  map: any,
  stillActive: () => boolean,
  config?: Promise<any>
): Promise<void> {
  await settings.loaded;
  if (!stillActive()) return;
  const base = await settings.getSetting("base");
  const area = selectedBaseArea(base, (await config)?.bases);
  if (!area || !stillActive()) return;
  await map.mapIsReady();
  if (!stillActive()) return;
  map.fitBaseArea(area);
}
